module.exports = __webpack_public_path__ + "static/media/singapore-gray.970e166b.svg";